var _excluded = ["children", "disabled"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Box } from "../box/Box";
import { _getBaseStyle } from "./Button.styles";
import Ripple from "./Ripple";
var BaseButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Ripple, null, function (_ref2) {
    var showRipple = _ref2.showRipple,
        ripple = _ref2.ripple;
    return /*#__PURE__*/React.createElement(Box, _extends({
      disabled: disabled,
      as: "button",
      ref: ref,
      onMouseDown: function onMouseDown(event) {
        var _props$onMouseDown;

        showRipple(event);
        (_props$onMouseDown = props.onMouseDown) === null || _props$onMouseDown === void 0 ? void 0 : _props$onMouseDown.call(props, event);
      }
    }, props, {
      _getBaseStyle: _getBaseStyle
    }), /*#__PURE__*/React.createElement(React.Fragment, null, children, ripple));
  });
});
BaseButton.displayName = 'Button';
var buttonDefaultProps = {
  appearance: 'ghost',
  palette: 'neutral',
  size: 'medium'
};
BaseButton.defaultProps = buttonDefaultProps;
export default BaseButton;
export { buttonDefaultProps };